'use clinet'

import SectionTitle from "@/components/etc/section_title";
import api from "@/util/api";
import moment from "moment";
import { useRouter } from "next/navigation";
import { useContext, useEffect, useRef, useState } from "react";
import ListV2 from "@/components/board/list_v2"
import { useLocale, useTranslations } from "next-intl";
import "moment/locale/ko";
import "moment/locale/en-gb";

import 'swiper/css';
import 'swiper/css/navigation';
import "swiper/css/autoplay";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import { DeviceContext } from "@/context/deviceContext";

export default function SportsAnalysisRanding() {
    const [listSportsAnalysis, setListSportsAnalysis] = useState<any[]>([])

    const router = useRouter()
    const locale = useLocale();
    const t = useTranslations('PageTitle')
    
    const fetchData = async () => {
        api(`/api/analysis/?page_count=6&page=1`)
            .then(res => res.json())
            .then(({ data }) => {
                setListSportsAnalysis(data?.posts ?? []);
            })
    };
    function setContentfunc(id :number){
        router.push(`/sportsanalysis/?id=${id}`)
    }

    useEffect(()=> {
        fetchData()
    }, [])

    return (
        <div className="p-r-5 p-l-5">
            <SectionTitle shortCut={`/sportsanalysis/`} type="sports-analysis" >{t.rich('스포츠 b:분석', { b: (chunks)=> <b>{chunks}</b> })}</SectionTitle>
            <ListV2 list={listSportsAnalysis} 
                    setContent={setContentfunc} 
                    className={`sports-analysis-list-new p-t-0`}
                    customStyle={{margin:"0", paddingBottom:0}}>
                {(list: any, idx: number) => (
                    <>
                        <div className={`date`}>{moment(list.game_time).locale(locale).format( locale === 'ko' ? 'MM월DD일(ddd) HH:mm' : "MMM DD (ddd) HH:mm" )}</div>

                        <div className={`home box w-40-per`}>
                            <div className={`img`}>
                                {
                                    list.home_team_logo
                                        ? <img className="team-amb" 
                                                src={list.home_team_logo} 
                                                alt=""
                                                onError={(e) => {
                                                    e.currentTarget.onerror = null;
                                                    e.currentTarget.src = `${require('@/public/image/etc/LogoA.png').default.src}`; 
                                                }} />
                                        : <img className="team-amb" src={require(`@/public/image/etc/LogoA.png`).default.src} alt="" />
                                }
                            </div>
                            <div className={`text`}>
                                <div>
                                    {(() => {
                                        const homeTeam = list.home_team || '';
                                        const len = Array.from(homeTeam).length;
                                        const fontSize = Math.max(12, Math.min(16, Math.round(20 - len * 0.7)));
                                        return <div style={{ fontSize: `${fontSize}px` }}>{homeTeam}</div>;
                                    })()}
                                    {/* {list.home_team} */}
                                </div>
                                <div className={`font-12`}>{list.home_info}</div>
                            </div>
                        </div>

                        <div className={`vs`}>VS</div>

                        <div className={`away box w-40-per`}>
                            <div className={`img`}>
                                {
                                    list.away_team_logo
                                        ? <img className="team-amb" 
                                                src={list.away_team_logo} 
                                                alt=""
                                                onError={(e) => {
                                                    e.currentTarget.onerror = null;
                                                    e.currentTarget.src = `${require('@/public/image/etc/LogoB.png').default.src}`; 
                                                }} />
                                        : <img className="team-amb" src={require(`@/public/image/etc/LogoB.png`).default.src} alt="" />
                                }
                            </div>
                            <div className={`text`}>
                                <div>
                                    {(() => {
                                        const homeTeam = list.away_team || '';
                                        const len = Array.from(homeTeam).length;
                                        const fontSize = Math.max(12, Math.min(16, Math.round(20 - len * 0.7)));
                                        return <div style={{ fontSize: `${fontSize}px` }}>{homeTeam}</div>;
                                    })()}
                                    {/* {list.away_team} */}
                                </div>
                                <div className={`font-12`}>{list.away_info}</div>
                            </div>
                        </div>
                        {(() => {
                            const league = list.league_name || '';
                            const len = Array.from(league).length;
                            const fontSize = Math.max(12, Math.min(16, Math.round(20 - len * 0.5)));
                            return (
                                <ETC league={league} fontSize={fontSize} />
                            )
                        })()}
                        {/* <div className={`etc`}>{list.league_name}</div> */}
                    </>
                )}
            </ListV2>
           
        </div>
    )
}


function ETC({ league, fontSize }: { league: string, fontSize: number }) {
    const { deviceWidth } = useContext(DeviceContext)
    const etcRef = useRef<HTMLDivElement>(null)
    const leagueRef = useRef<HTMLDivElement>(null)

    const [animation, setAnimation] = useState<boolean>(false)
    const [between, setBetween] = useState<number>(0)

    useEffect(() => {
        if (!etcRef.current || !leagueRef.current) return;

        const etc = etcRef.current
        const league = leagueRef.current

        // console.log("*********", `etc: ${etc.clientWidth}`, `league: ${league.clientWidth}`)
        if (etc.clientWidth < league.clientWidth) {
            // const calc = league.scrollWidth - etc.clientWidth
            // let duration = "2s"
            // if(calc < 50){
            //     duration = "3s"
            // }else if(calc < 20){
            //     duration = "1s"
            // }
            // league.style.setProperty("--duration", `${duration}`)
            // league.style.setProperty("--contentsWidth", `${etc.clientWidth - league.scrollWidth}px`)
            // console.log(`${etc.clientWidth - league.scrollWidth}px`)
            setBetween(league.clientWidth / 2)
            // console.log("*********", league.scrollWidth / 2)
            setAnimation(true)
        } else {
            setAnimation(false)
        }

    }, [league])
    return (
        <div className="etc" style={{ fontSize: `${fontSize}px` }} ref={etcRef}>
            {/* <div ref={leagueRef} className={animation ? "longContents" : ""}>{league}</div> */}
            <div ref={leagueRef} className="hidden">{league}</div>
            {
                animation
                    ? <>
                        <Swiper
                            modules={[Autoplay]}
                            loop={true}
                            spaceBetween={between || 40}
                            slidesPerView="auto"
                            speed={5000}
                            autoplay={{
                                delay: 0,                    // 자동 전환
                            }}
                        >
                            <SwiperSlide>
                                <div className="loop">{league}</div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className="loop">{league}</div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className="loop">{league}</div>
                            </SwiperSlide>
                        </Swiper>
                    </>
                    : <div className="normal">{league}</div>
            }
        </div>
    )
}
